<ng-container *ngIf="!buscando">
  <ng-container *ngIf="producto!=null; else: noproducto">
    <div class="d-flex flex-row justify-content-start align-items-center">
      <nav aria-label="breadcrumb" style="font-size: 13px;">
        <ol class="breadcrumb bg-transparent">
          <li class="breadcrumb-item"><a [routerLink]="['/productos']">CATEGORIAS</a></li>
          <li class="breadcrumb-item"><a [routerLink]="['/productos']"
                                         [queryParams]="{T:producto.art_tipprod}">{{ producto.tipoProducto }}</a></li>
          <li class="breadcrumb-item"><a [routerLink]="['/productos']"
                                         [queryParams]="{T:producto.art_tipprod,L:producto.art_linea}">{{ producto.linea }}</a>
          </li>
          <li class="breadcrumb-item"><a [routerLink]="['/productos']"
                                         [queryParams]="{T:producto.art_tipprod,L:producto.art_linea,R:producto.art_rubro}">{{ producto.rubro }}</a>
          </li>
          <li class="breadcrumb-item"><a [routerLink]="['/productos']"
                                         [queryParams]="{T:producto.art_tipprod,L:producto.art_linea,R:producto.art_rubro,F:producto.art_codtex}">{{ producto.marca }}</a>
          </li>
          <li class="breadcrumb-item active">{{ producto.art_descri }}</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex flex-row justify-content-end align-items-center">
      <div class="producto-titulo">
        <h2 class="text-center">{{ producto.art_descri }}</h2>
      </div>
      <div class="botton-deseado" *ngIf="currentUser!=null">
        <button mat-icon-button color="primary"
                [matTooltip]="producto.deseado?'Quitar de favoritos':'Añadir a favoritos'"
                (click)="aniadirDesaseado()"><span
          *ngIf="!producto.deseado"><i class="far fa-heart fa-3x"></i></span><span *ngIf="producto.deseado"><i
          class="fas fa-heart fa-3x"></i></span></button>
      </div>
    </div>
    <hr class="bg-naranja full-width" style="height: 2px;">
    <div class="d-flex flex-row flex-wrap justify-content-start align-items-start">
      <div class="col-md-6 col-lg-6 col-xl-6 text-center">
        <span class="new text-white bg-light-blue" *ngIf="isNew()">NEW</span>
        <span class="mas-vendido text-white bg-green" *ngIf="isMasVendido()">MÁS VENDIDO</span>
        <span class="new-mas-vendido text-white bg-green" *ngIf="isNewMasVendido()">MÁS VENDIDO</span>
        <span class="liquidacion text-white bg-red" *ngIf="isLiquidacion()">LIQUIDACIÓN</span>
        <img class="img-fluid" [src]="'https://melectricidad.com.ar/images/productosSistemas/'+generarURL()"
             [alt]="producto.art_descri" *ngIf="this.productoImag.length==0">
        <p-galleria [(value)]="productoImag" class="galeria-producto" [responsiveOptions]="responsiveOptions"
                    [numVisible]="4"
                    *ngIf="productoImag.length>0" [containerStyle]="{'max-width': '100%'}" [autoPlay]="true"
                    [circular]="true" [transitionInterval]="10000">
          <ng-template pTemplate="item" let-item>
            <img [src]="item.urlImagen" class="img-fluid" style="display: block;" [alt]="producto.art_descri"/>
          </ng-template>
          <ng-template pTemplate="thumbnail" let-item>
            <div class="p-grid p-nogutter p-justify-center">
              <img width="60" height="50" [src]="item.urlImagen" [alt]="producto.art_descri"/>
            </div>
          </ng-template>
        </p-galleria>
      </div>
      <div class=" col-md-6 col-lg-6 col-xl-6">
        <div class="d-flex flex-row flex-wrap justify-content-between align-items-start">
          <div class="producto-informacion">
            <div class="d-flex justify-content-start align-items-center">
              <span class="items-title">Marca:</span>
              <span class="items-info"><b><a [routerLink]="['/','productos']"
                                             [queryParams]="{marca: producto.art_codtex}">
                <ng-container *ngIf="marca==null; else imgMarca">
                  {{ producto.fab_descri }}
                </ng-container>

              </a></b></span>
              <span *ngIf="marca!=null && (marca.descripcion_publicidad && marca.descripcion_publicidad!='')">
                 <button mat-icon-button aria-label="info" (click)="infoMarca()" style="color: red" color="accent"
                         [matTooltip]="'Informacion Marca'">
                    <i class="fas fa-info-circle" style="font-size: 1.7em" aria-hidden="true"></i>
                </button>
              </span>
            </div>

            <div class="d-flex justify-content-start align-items-center">
              <span class="items-title">Codigo:</span>
              <span class="items-info">{{ producto.art_codtex }} {{ producto.art_codnum }}</span>
            </div>
            <ng-container *ngIf="currentUser!=null||producto.precioVisible=='1'">
              <div class="d-flex justify-content-start align-items-center" *ngIf="producto.descuento.length==0">
                <span class="items-title">Precio:</span>
                <span class="items-info">
                  <b class="precio-tachado" *ngIf="producto.oferta.length>0">$ {{ producto.precioFinal | number: '1.0-2' }}</b><span class="precio-tachado" *ngIf="producto.oferta.length>0"> x {{ producto.art_medida_descri | lowercase |slice: 0:1}}. </span><span class="descuento ml-1" *ngIf="producto.oferta.length>0">{{ producto.oferta[0].dto1 }}%</span><span *ngIf="producto.oferta.length>0">dto.</span>
                  <br *ngIf="producto.oferta.length>0"><b class="active-precio">${{ producto.resultado | number: '1.0-2' }} </b><span
                  class="oferta-compramin" *ngIf="producto.oferta.length>0">x {{ producto.oferta[0].minimo | number: '1.0-0' }} {{ producto.art_medida_descri | titlecase }}. </span>
                </span>
              </div>
              <div class="d-flex justify-content-start align-items-center" *ngIf="producto.descuento.length>0">
                <span class="items-title">Precio:</span>
                <span class="items-info" *ngIf="politicaSelect!=null"> <b
                  [class.active-precio]="politicaSelect!=null">$ {{ calcularPrecio() | number: '1.0-2' }}</b></span>
                <span class="items-info"><b [class.active-precio]="politicaSelect==null"
                                            [class.precio-tachado]="politicaSelect!=null">$ {{ producto.precioFinal | number: '1.0-2' }}</b></span>
              </div>
              <div id="sinImpuesto" class="d-flex justify-content-start align-items-center">
                <span class="items-title"></span>
                <span class="items-info text-light-gray items-info-sin-impuesto">Precio sin impuestos nacionales: ${{calcularPrecioSinImpuesto() | number: '1.0-2'}}</span>
              </div>
              <div class="d-flex justify-content-start align-items-center" *ngIf="producto.adicionales.length>0">
                <span class="items-title">Adicional:</span>
                <mat-form-field class="items-info">
                  <mat-select [(value)]="producto.adicionalSeleccionado" [compareWith]="compararFuncionCondicionIva">
                    <mat-option *ngFor="let adi of producto.adicionales" [value]="adi">{{ adi.adicional }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="d-flex justify-content-start align-items-center" *ngIf="producto.descuento.length>0">
                <span class="items-title"></span>
                <button type="button" class="btn btn-politica mr-1"
                        [class.botton-select]="politicaSelect!=null&&d.cantMin==politicaSelect.cantMin"
                        *ngFor="let d of producto.descuento" (click)="selectPolitica(d)"
                        style="margin-top: 5px; margin-bottom: 5px;">
                  <span>{{ d.dtoPV }}% x {{ d.cantMin }} {{ producto.art_medida_descri }}.</span>
                </button> &nbsp;
              </div>
              <div class="d-flex justify-content-start align-items-center" *ngIf="producto.embalaje!=null">
                <span class="items-title">Embalaje:</span>
                <span class="items-info"><span *ngIf="producto.embalaje!='0'">{{ producto.embalaje }}
                  x</span> {{ producto.tipo_embalaje }}</span>
              </div>
            </ng-container>
            <hr class="bg-naranja full-width" style="height: 1px;">
            <div class="d-flex  flex-wrap justify-content-between align-items-center mt-4">
              <div class="col-lg-4">
                <div class="input-group">
                  <div class="input-group-append">
                    <button class="btn btn-politica" type="button" [disabled]="cantidad<=1" (click)="disminuir()">-
                    </button>
                  </div>
                  <input class="form-control text-center" [(ngModel)]="cantidad" type="number" min="1"
                         (change)="selectPoliticaVTA()">
                  <div class="input-group-append">
                    <button class="btn btn-politica" type="button" (click)="incrementar()">+</button>
                  </div>
                </div>
              </div>
              <div class="col-lg-2"></div>
              <div class="col-lg-6">
                <div class="d-flex flex-row justify-content-end align-items-center">
                  <div class="d-block text-total mr-2">TOTAL</div>
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <div class="precio"><b>$ {{ calcularTotal() | number: '1.0-2' }}</b></div>
                    <div class="sub-text">IVA incluido</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2" *ngIf="isBotonCompraRedirect();else noSession">
              <button mat-raised-button class="full-width text-white btn-comprar mt-3" color="primary"
                      (click)="aniadirCarrito()"
                      *ngIf="(clicodigo!=null&&clicodigo!='0' &&producto.agotado=='0'&&producto.isProximamente=='0')"><i
                class="fas fa-cart-arrow-down"></i> Comprar
              </button>
              <button mat-raised-button class="full-width text-white btn-comprar mt-3 btn-agregar-carrito-agotado"
                      color="warn"
                      *ngIf="(clicodigo!=null&&clicodigo!='0'&&producto.agotado=='1')">Agotado
              </button>
              <button mat-raised-button class="full-width text-white btn-comprar mt-3" color="warn"
                      *ngIf="(clicodigo!=null&&clicodigo!='0'&&producto.isProximamente=='1')">Proximamente</button>
            </div>
            <div class="d-flex flex-row justify-content-start align-items-center mt-3">
              <a mat-mini-fab color="accent" class="mr-1 bg-gris" [href]="generarURLFA()" target="_blank"
                 [matTooltip]="'Compartir en Facebook'"><i class="fab fa-facebook icon-shared"></i></a>
              <a mat-mini-fab color="accent" class="bg-gris" [href]="generarURLWA()" target="_blank"
                 [matTooltip]="'Compartir en whatsapp'"><i class="fab fa-whatsapp icon-shared"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-start align-items-center my-3">
      <mat-tab-group class="bg-white full-width m-tabs">
        <mat-tab label="Descripcion" *ngIf="producto.descripcion!=null">
          <div class="my-3" [innerHTML]="producto.descripcion">

          </div>
        </mat-tab>
        <mat-tab label="Certificados" *ngIf="producto.certificados.length>0">
          <ul class="my-2">
            <li *ngFor="let cer of producto.certificados"><a [href]="cer.url_certificado"
                                                             target="_blank">{{ cer.nombre_certificado }}</a></li>
          </ul>
        </mat-tab>
        <mat-tab label="Video" *ngIf="producto.url_video!=null && this.producto.url_video!=''">
          <div class="my-3" [innerHTML]="this.video">

          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="d-flex flex-row justify-content-start align-items-center my-3">
      <app-producto-relacionado [tipoProd]="producto.art_tipprod"
                                [linea]="producto.art_linea"></app-producto-relacionado>
    </div>
  </ng-container>
</ng-container>
<ng-template #noproducto>
  <div class="d-flex flex-row justify-content-center align-items-center my-3">
    <p class="text-info">Producto no encontrado</p>
  </div>
  <div class="d-flex flex-row justify-content-start align-items-center my-3">
    <app-producto-relacionado [tipoProd]="''"
                              [linea]="''"></app-producto-relacionado>
  </div>
</ng-template>
<ng-template #imgMarca>
  <img [src]="marca.img" [alt]="producto.fab_descri" width="100" height="50">
</ng-template>

<ng-template #noSession>
  <div class="d-flex align-items-center mt-2">
    <button mat-raised-button class="full-width text-white btn-comprar mt-3" color="primary"
             [routerLink]="['/inicioSesion']"><i
      class="fas fa-cart-arrow-down"></i> Comprar
    </button>
  </div>
</ng-template>
